var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import "./TabsStyle.scss";
import { refresh } from "jsl-render";
import { helper } from "../../core/helper";
var TabsComponent = /** @class */ (function () {
    function TabsComponent(options) {
        var _a, _b, _c;
        this.options = options;
        this.State = { selectedIndex: null };
        this.options = (_a = this.options) !== null && _a !== void 0 ? _a : {};
        this.options.tabs = (_b = this.options.tabs) !== null && _b !== void 0 ? _b : [];
        this.options.selectedIndex = (_c = this.options.selectedIndex) !== null && _c !== void 0 ? _c : 0;
    }
    TabsComponent.prototype.getActiveTabIndex = function () {
        var _a;
        return (_a = this.State.selectedIndex) !== null && _a !== void 0 ? _a : this.options.selectedIndex;
    };
    TabsComponent.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        this.checkForDuplicateIds();
        var index = -1;
        var activeIndex = (_a = this.State.selectedIndex) !== null && _a !== void 0 ? _a : this.options.selectedIndex;
        if (activeIndex > -1 &&
            this.options.tabs[activeIndex].content == null &&
            this.options.tabs[activeIndex].onCreate) {
            this.options.tabs[activeIndex].content = this.options.tabs[activeIndex].onCreate();
        }
        var tabs = [];
        for (var idx = 0; idx < this.options.tabs.length; idx++) {
            if (!this.options.tabs[idx].id) {
                this.options.tabs[idx].id = helper.newDomGuid();
            }
            if (idx === activeIndex) {
                tabs.push({
                    tag: "div", attr: {
                        class: "tab-content " + ((_b = this.options.contentClass) !== null && _b !== void 0 ? _b : ""),
                        style: { "max-height": ((_c = this.options.maxHeight) !== null && _c !== void 0 ? _c : "100%") },
                        id: this.options.tabs[idx].id
                    },
                    children: [this.toNode(this.options.tabs[idx].content)]
                });
            }
            else if (this.options.preserveContent) {
                tabs.push({
                    tag: "div", attr: {
                        class: "tab-content tab-hidden " + ((_d = this.options.contentClass) !== null && _d !== void 0 ? _d : ""),
                        style: { "max-height": ((_e = this.options.maxHeight) !== null && _e !== void 0 ? _e : "100%") },
                        id: this.options.tabs[idx].id
                    },
                    children: [this.toNode(this.options.tabs[idx].content)]
                });
            }
        }
        return {
            tag: "div", attr: { class: "stabcomponent " + (this.options.class || ""), style: this.options.style }, children: __spreadArray([
                {
                    tag: "div", attr: { class: "tab-header-row" }, children: this.options.tabs.map(function (x) {
                        index++;
                        var currIndex = index;
                        return {
                            tag: "div", attr: {
                                class: "tab-item " + (index === activeIndex ? "active " : "") + (_this.options.tabs[currIndex].enabled === false ? "disabled " : ""),
                                click: function (evt) {
                                    var _a;
                                    if ((_a = _this.options.tabs[currIndex].enabled) !== null && _a !== void 0 ? _a : true) {
                                        _this.SetSelectedTab(currIndex);
                                        if (_this.options.onSelect) {
                                            _this.options.onSelect(currIndex);
                                        }
                                    }
                                }
                            }, children: [
                                { tag: "span", attr: { style: "vertical-align: middle; vertical-align: -webkit-baseline-middle; vertical-align: -moz-middle-with-baseline;" }, children: [_this.toNode(x.header, "span")] },
                                _this.options.tabs[index].canClose
                                    ?
                                        {
                                            tag: "div", attr: {
                                                class: "close-button", click: function (evt) {
                                                    var _a;
                                                    if ((_a = _this.options.tabs[currIndex].enabled) !== null && _a !== void 0 ? _a : true) {
                                                        evt.stopPropagation();
                                                        _this.closeTabIndex(currIndex, true);
                                                    }
                                                }
                                            }, content: "X"
                                        }
                                    :
                                        undefined
                            ]
                        };
                    })
                }
            ], tabs, true)
        };
    };
    TabsComponent.prototype.AddTab = function (tabItem) {
        var _a;
        tabItem.enabled = (_a = tabItem.enabled) !== null && _a !== void 0 ? _a : true;
        this.options.tabs.push(tabItem);
        this.checkForDuplicateIds();
        return this.options.tabs.length - 1;
    };
    TabsComponent.prototype.EnableAll = function () {
        for (var i = 0; i < this.options.tabs.length; i++) {
            this.options.tabs[i].enabled = true;
        }
        if (this.renderer != null) {
            this.renderer.refresh();
        }
        else {
            refresh();
        }
    };
    TabsComponent.prototype.DisableAll = function () {
        for (var i = 0; i < this.options.tabs.length; i++) {
            this.options.tabs[i].enabled = false;
        }
        if (this.renderer != null) {
            this.renderer.refresh();
        }
        else {
            refresh();
        }
    };
    TabsComponent.prototype.GetByID = function (id) {
        return this.options.tabs.filter(function (f) { return f.id === id; })[0];
    };
    TabsComponent.prototype.closeTabIndex = function (index, raiseSelectEvent) {
        var _a, _b;
        // console.log("closing tab index " + index);
        if (this.options.tabs[index].onClosing) {
            if (this.options.tabs[index].onClosing() === false) {
                return false;
            }
        }
        this.options.tabs = this.options.tabs.filter(function (_, currIdx) { return currIdx !== index; });
        var newSelectedIndex = (_b = (_a = this.State.selectedIndex) !== null && _a !== void 0 ? _a : this.options.selectedIndex) !== null && _b !== void 0 ? _b : 0;
        if (this.options.tabs.length <= newSelectedIndex) {
            newSelectedIndex--;
            this.SetSelectedTab(newSelectedIndex);
        }
        if (raiseSelectEvent) {
            if (this.options.onSelect) {
                this.options.onSelect(newSelectedIndex);
            }
        }
        return true;
    };
    // public onCreate(node: IJSLVNode) {
    //     this.ref = node.dom as HTMLDivElement;
    // }
    // public onUpdate(node: IJSLVNode) {
    //     this.ref = node.dom as HTMLDivElement;
    // }
    TabsComponent.prototype.onInit = function (renderer) {
        this.renderer = renderer;
    };
    TabsComponent.prototype.SetSelectedTab = function (index) {
        var _a;
        if (((_a = this.options.tabs[index]) === null || _a === void 0 ? void 0 : _a.onCreate) != null && this.options.tabs[index].content == null) {
            this.options.tabs[index].content = this.options.tabs[index].onCreate();
        }
        this.options.selectedIndex = index;
        this.State.selectedIndex = index;
        if (this.renderer != null) {
            this.renderer.refresh();
        }
        else {
            refresh();
        }
    };
    TabsComponent.prototype.toNode = function (content, tag) {
        if (content == null) {
            return undefined;
        }
        if (typeof content === "string") {
            return { tag: tag !== null && tag !== void 0 ? tag : "div", content: content };
        }
        return content;
    };
    TabsComponent.prototype.checkForDuplicateIds = function () {
        if (this.options.tabs == null || this.options.tabs.length === 0) {
            return;
        }
        var ids = {};
        for (var _i = 0, _a = this.options.tabs; _i < _a.length; _i++) {
            var tab = _a[_i];
            if (tab.id && ids[tab.id] !== undefined) {
                throw new Error("Tab Control has duplicate id " + tab.id);
            }
        }
    };
    return TabsComponent;
}());
export { TabsComponent };
